import React from 'react'
import { Col } from '@tools/wr-catalog-base'
import FiltersDropdown from '@components/FiltersDropdown'
import SortingDropdown from '@components/SortingDropdown'
import ExportButton from './ExportButton'

import { ContainerRow } from './styles'

const Toolbar = ({ renderedParts }) => {
  return (
    <ContainerRow center="xs">
      <Col xs>{renderedParts.textFilter}</Col>
      <Col xs>
        <FiltersDropdown
          buttonProps={{ 'data-track': 'click', 'data-name': 'main-page-control', 'data-title': 'Choose Region' }}
        />
      </Col>
      <Col xs>
        <SortingDropdown />
      </Col>
      <Col xs>
        <ExportButton />
      </Col>
    </ContainerRow>
  )
}

export default Toolbar
